import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { FiAlertCircle, FiHome, FiRefreshCw } from "react-icons/fi";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
    
    // You can also log the error to an error reporting service here
    // Example: logErrorToService(error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container fluid className="about-section" style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Container>
            <Row style={{ justifyContent: "center" }}>
              <Col md={8} style={{ textAlign: "center", color: "white" }}>
                <div style={{ fontSize: "4em", marginBottom: 20, color: "var(--color-primary)" }}>
                  <FiAlertCircle />
                </div>
                <h1 style={{ fontSize: "2em", marginBottom: 16, color: "var(--color-primary)" }}>
                  Something went wrong
                </h1>
                <p style={{ fontSize: "1.1em", marginBottom: 24, opacity: 0.9 }}>
                  We're sorry, but something unexpected happened. Please try refreshing the page or return to the homepage.
                </p>
                {process.env.NODE_ENV === 'development' && this.state.error && (
                  <details style={{ 
                    textAlign: "left", 
                    marginBottom: 24, 
                    padding: 16, 
                    background: "rgba(20, 184, 166, 0.1)", 
                    borderRadius: 8,
                    border: "1px solid rgba(20, 184, 166, 0.3)"
                  }}>
                    <summary style={{ cursor: "pointer", marginBottom: 8, fontWeight: 600 }}>
                      Error Details (Development Only)
                    </summary>
                    <pre style={{ 
                      fontSize: "0.85em", 
                      overflow: "auto",
                      color: "#eaeaea"
                    }}>
                      {this.state.error.toString()}
                      {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </pre>
                  </details>
                )}
                <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
                  <Button 
                    className="btn-resume magnetic" 
                    onClick={this.handleReset}
                    aria-label="Try again"
                  >
                    <FiRefreshCw style={{ marginRight: 8 }} />
                    Try Again
                  </Button>
                  <Button 
                    className="btn-ghost magnetic" 
                    href="/"
                    aria-label="Return to homepage"
                  >
                    <FiHome style={{ marginRight: 8 }} />
                    Go Home
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

